import {ContactAction, ContactLine, formatPhone} from '@/components/common/profileUi/profileUi.helper';
import {Place} from '@/interfaces/place.interface';

const CONTACT_FIELDS: Array<{ key: string; label: string; icon: string; actions: ContactAction[]; phone?: boolean }> = [
    {key: 'phone1', label: 'Telefon', icon: 'mdi-phone-outline', actions: ['call'], phone: true},
    {key: 'phone2', label: 'Telefon', icon: 'mdi-phone-outline', actions: ['call'], phone: true},
    {key: 'mobile1', label: 'Mobil', icon: 'mdi-cellphone', actions: ['call', 'whatsapp'], phone: true},
    {key: 'mobile2', label: 'Mobil', icon: 'mdi-cellphone', actions: ['call', 'whatsapp'], phone: true},
    {key: 'mail1', label: 'E-Mail', icon: 'mdi-email-outline', actions: ['mail']},
    {key: 'mail2', label: 'E-Mail', icon: 'mdi-email-outline', actions: ['mail']},
    {key: 'fax1', label: 'Fax', icon: 'mdi-fax', actions: [], phone: true},
    {key: 'fax2', label: 'Fax', icon: 'mdi-fax', actions: [], phone: true},
    {key: 'website', label: 'Website', icon: 'mdi-web', actions: ['visit']},
];

/** Contact lines of the card dialogs (same keys, formatting and notes as the former contactDataListItems) */
export function contactLinesOf(contactInformation: unknown): ContactLine[] {
    const contact = (contactInformation || {}) as Record<string, any>;
    const notes = (contact.notes || {}) as Record<string, string>;
    return CONTACT_FIELDS.filter((field) => !!contact[field.key]).map((field) => ({
        label: field.label,
        icon: field.icon,
        actions: field.actions,
        value: field.phone ? formatPhone(contact[field.key]) : contact[field.key],
        note: notes[field.key],
    }));
}

export function addressTextOf(address?: Partial<Place>): string {
    return address ? `${address.street || ''} ${address.houseNumber || ''}, ${address.postal || ''} ${address.city || ''}`.trim() : '';
}

export function mapsLinkOf(query: string): string {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}
